var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { layout, space } from 'styled-system';
import { css, styled } from "../utils";
var Bar = styled.div(function (_a) {
    var colors = _a.theme.colors;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    height: 5px;\n    min-width: 50px;\n    border-radius: 2px;\n  "], ["\n    background: ", ";\n    height: 5px;\n    min-width: 50px;\n    border-radius: 2px;\n  "])), colors.gray3);
}, space, layout);
var Progress = styled(Bar)(function (_a) {
    var color = _a.color, percentage = _a.percentage, colors = _a.theme.colors;
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    background: ", ";\n    width: ", ";\n    min-width: auto;\n    height: 100%;\n  "], ["\n    background: ", ";\n    width: ", ";\n    min-width: auto;\n    height: 100%;\n  "])), color || colors.primary, percentage);
});
var ProgressBar = function (_a) {
    var color = _a.color, percentage = _a.percentage, props = __rest(_a, ["color", "percentage"]);
    return (React.createElement(Bar, __assign({ "data-component": "ProgressBar" }, props),
        React.createElement(Progress, { color: color, percentage: percentage })));
};
export default ProgressBar;
var templateObject_1, templateObject_2;
//# sourceMappingURL=ProgressBar.js.map